import React from 'react';

export default function NavFooter() {
    return (
        <nav className='social'>
            <ul >
                <li>Twitter</li>
                <li>Instagram</li>
                <li>Facebook</li>
                <li>Contact Us</li>
            </ul>   
        </nav>
    );
}


